// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c1843dc9","513":"1efcf0ec","703":"fba78f85"}[chunkId] + ".chunk.js";
};